/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import type { SVGProps } from 'react';

const CircularLockIcon = ({
  color = 'currentColor',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={60}
    height={60}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="CircularLockIcon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 57.5c15.188 0 27.5-12.312 27.5-27.5S45.188 2.5 30 2.5 2.5 14.812 2.5 30 14.812 57.5 30 57.5Zm0 2.5c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30Z"
      fill={color}
    />
    <path
      d="M30.087 32.59a2.41 2.41 0 0 0-1.09 4.55V40h2v-2.77a2.41 2.41 0 0 0-.91-4.64Z"
      fill={color}
    />
    <path
      d="M38 27v-4.28a8.2 8.2 0 0 0-8-8.36 8.2 8.2 0 0 0-8 8.36V27h-3v17a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V27h-3Zm-14-4.28a6.2 6.2 0 0 1 6-6.36 6.2 6.2 0 0 1 6 6.36V27H24v-4.28ZM21 44V29h18v15H21Z"
      fill={color}
    />
  </svg>
);

export default CircularLockIcon;
